// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo--qpFGh{width:20rem}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/Ofcom/index.module.scss"],"names":[],"mappings":"AAAA,aAAM,WAAW","sourcesContent":[".logo{width:20rem}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": "logo--qpFGh"
};
export default ___CSS_LOADER_EXPORT___;
